<template>
  <div style="margin-top: 10px">
    <WidgetsDropdown />
    <CCard>
      <CCardBody>
        <!-- <button @click="logOut()">logOut</button> -->
        <CRow>
          <CCol sm="12">
            <h4 id="traffic" class="card-title mb-0" v-if="allchartview">
              All Token Graph
            </h4>
            <h4 id="traffic" class="card-title mb-0" v-if="mainChart">
              {{ this.grapdata }} Graph

              <!-- <div class="small text-muted">November 2017</div> -->
              <CButton style="float: right" color="success" @click="gograph()"
                >Go to all graph</CButton
              >
            </h4>
          </CCol>

          <!-- <CCol sm="7" class="d-none d-md-block">
            <CButton color="primary" class="float-right">
              <CIcon name="cil-cloud-download" />
            </CButton>
            <CButtonGroup class="float-right mr-3">
              <CButton
                color="outline-secondary"
                v-for="(value, key) in ['Day', 'Month', 'Year']"
                :key="key"
                class="mx-0"
                :pressed="value === selected ? true : false"
                @click="selected = value"
              >
                {{ value }}
              </CButton>
            </CButtonGroup>
          </CCol> -->
        </CRow>
        <!-- <MainChartExample
          style="height: 300px; margin-top: 40px"
          v-if="mainChart"
        /> -->
        <!-- <CChartLine
          :datasets="defaultDatasets"
          :options="defaultOptions"
          v-if="mainChart"
          style="height: 300px; margin-top: 40px"
        /> -->
        <div id="chart">
          <Apexchart
            type="area"
            height="350"
            v-if="mainChart"
            :options="defaultOptions"
            :series="defaultDatasets"
          ></Apexchart>
        </div>
        <Allchart style="height: 300px; margin-top: 40px" v-if="allchartview" />
      </CCardBody>
    </CCard>
    <WidgetsBrand />
    <!-- <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader> Capture Details </CCardHeader>
          <CCardBody>
            <CDataTable
              :items="tableData2"
              :fields="fields"
              column-filter
              table-filter
              items-per-page-select
              :items-per-page="10"
              hover
              sorter
              pagination
            >
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow> -->
  </div>
</template>

<script>
import MainChartExample from "./charts/MainChartExample";
import Allchart from "./charts/allchart";
import WidgetsDropdown from "./widgets/WidgetsDropdown";
import WidgetsBrand from "./widgets/WidgetsBrand";
import firebase from "firebase";
import { CChartLine } from "@coreui/vue-chartjs";
import { getStyle, hexToRgba } from "@coreui/utils/src";
import Apexchart from "vue-apexcharts";
const db = firebase.firestore();
export default {
  name: "Dashboard",
  components: {
    Apexchart,
    MainChartExample,
    WidgetsDropdown,
    WidgetsBrand,
    Allchart,
    CChartLine,
    // name:{
    //    type:Array,
    //    default:() =>[this.name]
    // }
  },
  data() {
    return {
      tooltips: [],
      selected: "Day",
      fielterdata: "",
      allchartview: true,
      mainChart: false,
      tokenList: "",
      grapdiv: [],
      allgraph: [],
      graph: [],
      options: [],
      tableData: [],
      tableData1: [],
      tokenBal: [],
      grapdata: "",
      tableToken: [],
      tokenLength: "",
      totalToken: "",
      total: 0,
      fields: [
        {
          label: "ID",
          key: "id",
          sortable: true,
        },
        {
          label: "Token count",
          key: "TRAGE",
          sortable: true,
        },
      ],
      details: [],
      collapseDuration: 0,
    };
  },
  computed: {
    defaultDatasets() {
      const brandSuccess = getStyle("success") || "#4dbd74";
      const brandInfo = getStyle("info") || "#20a8d8";
      const brandDanger = getStyle("danger") || "#f86c6b";

      let elements = 3;
      const data1 = [];
      const data2 = [];
      const data3 = [];
      let tdata = [];
      for (let i in this.tokenList) {
        let name = [];
        let count = [];
        for (let j = 0; j < this.tokenList[i].length; j++) {
          if (this.tokenList[i][j].name && this.tokenList[i][j].count) {
            name.push(this.tokenList[i][j].name);
            count.push(
              this.tokenList[i][j].count + "$" + this.tokenList[i][j].name
            );
          }
        }
        this.tooltips.push(name);
        tdata.push({
          name: i,
          labels: name,
          backgroundColor: hexToRgba(brandInfo, 10),
          borderColor: brandInfo,
          pointHoverBackgroundColor: brandInfo,
          borderWidth: 2,
          data: count,
        });
      }
      return tdata;
    },
    defaultOptions() {
      return {
        chart: {
          height: 350,
          type: "area",
        },
        // dataLabels: {
        //   enabled: true,
        //   enabledOnSeries: true,
        //   formatter: function (val, opts) {
        //     return "123456789";
        //   },
        // },
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            let mail =
              w.config.series[seriesIndex].data[dataPointIndex].split("$");
            return (
              '<div class="arrow_box">' +
              "<span>" +
              mail[1] +
              "</span>" +
              "</div>"
            );
          },
        },
        stroke: {
          curve: "smooth",
        },
      };
    },
  },
  mounted() {
    this.$root.$on("datasent", (value) => {
      this.total = "";
      this.grapdata = value;
      this.allchartview = false;
      this.mainChart = true;
      this.onChange();
    });
  },
  methods: {
    gograph() {
      this.allchartview = true;
      this.mainChart = false;
      location.reload();
    },
    onChange() {
      let token = [];
      // this.total = "";
      db.collection("collectedCoins2")
        .where(this.grapdata, "!=", null)
        // .limit(100)
        .get()
        .then((snapshot) => {
          for (let doc of snapshot.docs) {
            for (let usertoken in doc.data()) {
              if (usertoken == this.grapdata) {
                if (doc.data()[usertoken].length > 0) {
                  if (token[usertoken]) {
                    token[usertoken].push({
                      name: doc.id,
                      count: doc.data()[usertoken].length,
                    });
                  } else {
                    token[usertoken] = [];
                    token[usertoken].push({
                      name: doc.id,
                      count: doc.data()[usertoken].length,
                    });
                  }
                }
              }
            }
          }
          this.tokenList = token;
          // for (let doc of snapshot.docs) {
          //     let name = [];
          //     let count = [];
          //   if (doc.data()[this.grapdata].length == 0) {
          //     this.tableData.push(doc.data()[this.grapdata].length);
          //     this.tokenBal = [];
          //   } else {
          //     this.tokenBal.push({
          //       name:doc.id,
          //       count:doc.data()[this.grapdata].length
          //     });

          //   }
          // }
          // this.tokenList = this.tokenBal;
        });
    },
    color(value) {
      let $color;
      if (value <= 25) {
        $color = "info";
      } else if (value > 25 && value <= 50) {
        $color = "success";
      } else if (value > 50 && value <= 75) {
        $color = "warning";
      } else if (value > 75 && value <= 100) {
        $color = "danger";
      }
      return $color;
    },

    logOut() {
      const auth = firebase.auth();
      auth
        .signOut()
        .then(() => {
          localStorage.clear();
          this.$router.push({ name: "LoginPage" });
          location.reload();
        })
        .catch(function (error) {
          // An error happened
          alert("Error Occured");
        });
    },
  },
  created() {
    //  this.mainChart = true;.
    // this.$root.$emit("backupdataon", this.backup);

    this.articles = JSON.parse(localStorage.getItem("data")); //push all data to this.articles
    // let AllgraphData = JSON.parse(localStorage.getItem("Allgrapdata"))

    //        this.$root.$emit("allgrapdata",AllgraphData)
  },
};
</script>
